
import React from 'react';
import cn from 'classnames';
import StatusBoxComponent from 'components/StatusBoxComponent';
// import assets from './assets';
import styles from './StatusBarBox.module.scss';
import assetsObject from './assetsObject';
// import assets from './assets';

export default function SideBarBox(props) {
  return (
    <div id="status_main_Data_block" className={`SideBarBox ${cn(styles.block5, styles.block5_layout1)}`}>
      <div id="status_main_Data_layout" className={cn(styles.flex1, styles.flex1_layout)}>
        <h5 id="status_Heading" className={cn(styles.highlights, styles.highlights_layout)}>
          {props?.data?.header}
        </h5>
        <hr className={cn(styles.line, styles.line_layout)} />
        <div id="status_Data_text" className={cn(styles.flex, styles.flex_layout)}>
        {props?.data?.components.map((item,index)=>{
         return <StatusBoxComponent
         img={
           assetsObject[item.img]
          //  require('assets/total_energy.png').default
          //  src={assets}
          //  require(`${item.img}`).default
         }
         title={item.title}
         value={item.value}
       />
     })}
        

          {/* <StatusBoxComponent
            img={
              require('assets/6a2ed30ef31e31e3fae37100197b47cb.png').default
            }
            title={'{{text12}}'}
            value={'{{text1234}}'}
          /> */}
        </div>
      </div>
    </div>
  );
}

SideBarBox.inStorybook = true;
